/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками SOS
 */

/**
 * Сервис управления настройками SOS
 */
export class SosServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек SOS
   */
  EditSos = (req: Pick<EditSosRequestDto, "updateMask"> & { data: SosRequestDto & fm.RequireAtLeastOne<SosRequestDto> }, init?: RequestInit): Promise<EditSosResponseDto> => {
    return fm.request<Pick<EditSosRequestDto, "updateMask"> & { data: SosRequestDto & fm.RequireAtLeastOne<SosRequestDto> }, EditSosResponseDto>(`${this.host}/device/api/v1/sos`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек SOS
   */
  GetSos = (req?: GetSosRequestDto, init?: RequestInit): Promise<GetSosResponseDto> => {
    return fm.request<GetSosRequestDto, GetSosResponseDto>(`${this.host}/device/api/v1/sos${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос редактирования настроек SOS
 */
export type EditSosRequestDto = {
  /**
   * Настройки SOS
   */
  data: SosRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек SOS
 */
export type EditSosResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки SOS
   */
  readonly data: SosResponseDto
  /**
   * Ошибка
   */
  readonly error: EditSosResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditSosResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditSosResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек SOS
 */
export type GetSosRequestDto = {
}
/**
 * Ответ на запрос получения настроек SOS
 */
export type GetSosResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки SOS
   */
  readonly data: SosResponseDto
}>
/**
 * Настройки SOS
 */
export type SosRequestDto = {
  /**
   * Флаг включения SOS вызова
   */
  isSosOn: boolean
  /**
   * Параметр SIP Invite для SOS вызова.
   * Произвольная строка которая передается в SIP сервер.
   * Диапазон: 1..128
   */
  sipInvite: string
  /**
   * Параметр SIP Server для SOS вызова.
   * При пустом sip_server будет использован сервер SIP регистрации
   */
  sipServer?: string
}
/**
 * Настройки SOS
 */
export type SosResponseDto = {
  /**
   * Флаг включения SOS вызова
   */
  isSosOn: boolean
  /**
   * Параметр SIP Invite для SOS вызова.
   * Произвольная строка которая передается в SIP сервер.
   * Диапазон: 1..128
   */
  sipInvite: string
  /**
   * Параметр SIP Server для SOS вызова.
   * При пустом sip_server будет использован сервер SIP регистрации
   */
  sipServer: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования настроек SOS
   */
  "EditSosRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек SOS",
    "fields": {
      /**
       * Настройки SOS
       */
      "data": {
        "type": "Sos",
        "text": "Настройки SOS",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек SOS
   */
  "EditSosResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек SOS",
    "fields": {
      /**
       * Настройки SOS
       */
      "data": {
        "type": "Sos",
        "text": "Настройки SOS",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "EditSosResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditSosResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек SOS
   */
  "GetSosRequest": {
    "kind": "class",
    "text": "Запрос получения настроек SOS",
  },
  /**
   * Ответ на запрос получения настроек SOS
   */
  "GetSosResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек SOS",
    "fields": {
      /**
       * Настройки SOS
       */
      "data": {
        "type": "Sos",
        "text": "Настройки SOS",
      },
    },
  },
  /**
   * Настройки SOS
   */
  "Sos": {
    "kind": "class",
    "text": "Настройки SOS",
    "fields": {
      /**
       * Флаг включения SOS вызова
       */
      "isSosOn": {
        "type": "bool",
        "text": "Флаг включения SOS вызова",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр SIP Invite для SOS вызова.
       * Произвольная строка которая передается в SIP сервер.
       * Диапазон: 1..128
       */
      "sipInvite": {
        "type": "string",
        "text": "Параметр SIP Invite для SOS вызова.\nПроизвольная строка которая передается в SIP сервер.\nДиапазон: 1..128",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр SIP Server для SOS вызова.
       * При пустом sip_server будет использован сервер SIP регистрации
       */
      "sipServer": {
        "type": "string",
        "text": "Параметр SIP Server для SOS вызова.\nПри пустом sip_server будет использован сервер SIP регистрации",
      },
    },
  },
}